// extracted by mini-css-extract-plugin
module.exports = {"checkBoxesBlock":"CommentOptions_checkBoxesBlock__3w7yz","checkBox":"CommentOptions_checkBox__1LzoR"};